/**
 * SwipeDup (A43.1) — обвязка «свайп-вправо = дубликат» для collapsed-строки
 * карточки (квест/спецверсия): строка едет transform'ом за пальцем
 * (useSwipeRight), из-под неё показывается green-зона «⧉ Дубликат»;
 * отпускание за порогом зовёт onDup (открытие предзаполненной формы —
 * в БД клон попадает только по «Создать»), раньше порога — пружина назад.
 * touch-action: pan-y на строке — вертикальный скролл остаётся браузеру.
 */
import type { MouseEvent as ReactMouseEvent, ReactNode } from "react";
import { useSwipeRight } from "../../hooks/useSwipeRight";
import css from "./quests.module.css";

export interface SwipeDupProps {
  /** true — жест выключен (например, карточка раскрыта). */
  disabled: boolean;
  onDup: () => void;
  /** Классы строки (например css.qrow — падинги/курсор сохраняются). */
  className?: string;
  onClick: () => void;
  children: ReactNode;
}

export function SwipeDup({ disabled, onDup, className, onClick, children }: SwipeDupProps) {
  const sw = useSwipeRight(onDup, disabled);
  const stop = (e: ReactMouseEvent<HTMLElement>) => { e.preventDefault(); e.stopPropagation(); };
  return (
    <div className={css.swWrap}>
      {/* Зона живёт всегда (в покое накрыта непрозрачной строкой): при
          пружине назад зелёное остаётся под строкой до конца анимации. */}
      <div className={`${css.swZone} ${sw.ready ? css.swOn : ""}`} aria-hidden="true">
        <span className={css.swGlyph}>⧉</span> Дубликат
      </div>
      <div
        className={`${className ?? ""} ${css.swRow} ${sw.active ? "" : css.swEase}`}
        style={sw.dx ? { transform: `translateX(${sw.dx}px)` } : undefined}
        onClick={onClick}
        onContextMenu={sw.active ? stop : undefined}
        {...sw.handlers}
      >
        {children}
      </div>
    </div>
  );
}
